var _defs, _rect, _text, _path, _g, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _polyline, _rect2, _path21, _path22, _rect3, _rect4, _circle, _circle2, _rect5, _rect6, _text2, _polygon, _circle3, _circle4, _text3, _circle5, _circle6, _text4, _circle7, _circle8, _text5, _rect7, _circle9, _circle0, _circle1, _polyline2, _line, _line2, _line3, _line4, _circle10, _polygon2, _path23, _path24, _path25, _path26, _path27, _path28, _circle11, _polygon3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaidadvertisingtab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 765 277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-13,.cls-15,.cls-17,.cls-18,.cls-19,.cls-26,.cls-30{fill:none;}.cls-2{fill:#d8c4df;}.cls-3{font-size:35px;}.cls-22,.cls-23,.cls-24,.cls-25,.cls-3,.cls-7{fill:#2f2143;}.cls-22,.cls-23,.cls-24,.cls-25,.cls-3{font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-4{fill:#544741;}.cls-5{clip-path:url(#clip-path);}.cls-6{fill:#c7b299;}.cls-8{clip-path:url(#clip-path-2);}.cls-9{fill:#5e443c;}.cls-10{fill:#fabba2;}.cls-11{fill:#ffc20e;}.cls-12{fill:#e3987d;}.cls-13{stroke:#ffc20e;stroke-width:0.2px;}.cls-13,.cls-15,.cls-17,.cls-18,.cls-19,.cls-26,.cls-30{stroke-miterlimit:10;}.cls-14{fill:#fff;}.cls-15{stroke:#544741;stroke-width:0.8px;}.cls-16{fill:#9a499c;}.cls-17,.cls-26{stroke:#002f3e;}.cls-17{stroke-width:2.41px;}.cls-18,.cls-19{stroke:#9a499c;}.cls-18{stroke-width:1.37px;}.cls-19{stroke-width:1.08px;}.cls-20{fill:#aad3f1;}.cls-21{fill:#7ebfe9;}.cls-22{font-size:20.35px;}.cls-23{font-size:16.56px;}.cls-24{font-size:12.63px;}.cls-25{font-size:15.4px;}.cls-26{stroke-width:1.5px;}.cls-27{fill:#263238;}.cls-28{fill:#fdc435;}.cls-29{fill:#daa228;}.cls-30{stroke:#2f2143;stroke-width:3.03px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.8,246l-3.36,23.08H123a12.06,12.06,0,0,0-2.76-6.68,13.27,13.27,0,0,0-10-4.45,16.15,16.15,0,0,1-7.21-.77,22.48,22.48,0,0,1,1.2-11.18Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.66,247.31l12.28,19.84,26.45-22.24a12,12,0,0,0-6.42-3.34,13.24,13.24,0,0,0-10.5,3,17.59,17.59,0,0,1-4.18,3.21,15.65,15.65,0,0,1-1.83.84,22,22,0,0,1-4.06-4.75,22.78,22.78,0,0,1-2.23-4.58Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "paid advertising tab") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 765,
    height: 277
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(256.02 168.34)"
  }, "PAID ADVERTISING")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M123,269.08H88.44L91.8,246h12.43a22.48,22.48,0,0,0-1.2,11.18,16.15,16.15,0,0,0,7.21.77,13.27,13.27,0,0,1,10,4.45,12.06,12.06,0,0,1,2.76,6.68"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "88.9 265.88 111.2 265.88 116.5 259.49 128.17 259.49 125.55 269.97 86.22 270.91 88.9 265.88"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M37.54,268.38h0a2.84,2.84,0,0,0,3.35-2.18L54.4,202.45a2.82,2.82,0,1,0-5.52-1.17L35.36,265a2.84,2.84,0,0,0,2.18,3.35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M62.33,270.11h0a2.83,2.83,0,0,0,2.82-2.82V202.12a2.83,2.83,0,0,0-5.65,0v65.17a2.83,2.83,0,0,0,2.83,2.82"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M86.16,269h0a2.84,2.84,0,0,0,2.22-3.32L75.79,201.77a2.83,2.83,0,0,0-5.55,1.09l12.6,63.94A2.83,2.83,0,0,0,86.16,269"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M168.39,244.91l-26.45,22.24-12.28-19.84,9.51-8a22.78,22.78,0,0,0,2.23,4.58,22,22,0,0,0,4.06,4.75,15.65,15.65,0,0,0,1.83-.84,17.59,17.59,0,0,0,4.18-3.21,13.24,13.24,0,0,1,10.5-3,12,12,0,0,1,6.42,3.34"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "140.24 264.4 157.31 250.04 157.25 241.74 166.18 234.23 170.92 243.94 141.43 269.97 140.24 264.4"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M79.57,203.11H43.64a3.22,3.22,0,1,1,0-6.44H79.57a3.22,3.22,0,1,1,0,6.44"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M78.77,197.33l27.34,17.57,21.57,38.56L149,239s-15.35-30-31-40.28Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M80.19,62.68c1.93-.06,3.91,4.47,4.54,5.92a21.11,21.11,0,0,1,.53,14.66l-2.18,3.6a16.17,16.17,0,0,1,5.65,10.25c1,8.18-5.1,13.65-5.65,14.13a7.37,7.37,0,0,1-3.78,1.31c-3.21.16-6.38-2-8.17-5.49C74.36,70.54,77.69,62.77,80.19,62.68Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M81.52,251.4l34,1.83,2.46-53a20.38,20.38,0,0,0-2.9-11c-3.3-5.39-8.45-7.43-11-8.43-1.67-.65-3.91-1.32-16-2-4.47-.25-8.18-.38-10.78-.46l-39.95-1.75s-3.71,19.79,17.3,21L90,201.21Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M71.93,105.52s-.46-5.88.63-9.08c0,0,11.74,2.38,11.57-10,0,0,2.63-1.72,2.44-3.89,0,0-3.92-1.06-4-7.22,0,0,.92-6.11-2.34-9.82,0,0-31.87-17.87-22,37.6Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M78.72,112.6l-4,20.09s12.94,12.72,17.08,15.11c0,0,1.91,1.62,6,1.13l35-5.54L132,131.81l-31.94,4.72Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M38.59,177.25,78.82,179s5.81-55.49,3.3-61.56c0,0-.42-4.91-6.35-10.95l-19.92-6.29s-10.13,6.43-12.14,23.22L35.37,169s-.84,6.64,3.22,8.27"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M142.41,133.3c.53.56,1.06,1.13,1.6,1.69,0,.07.93,1.63.54,2s-1.28-.17-2.41-1.11l-1.69-1.75Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M144.76,131l1.61,1.69c0,.08.93,1.63.54,2s-1.28-.18-2.41-1.12c-.57-.58-1.13-1.17-1.69-1.75Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M147.08,130.64c.54.56,1.07,1.13,1.6,1.69,0,.07.94,1.63.55,2s-1.28-.17-2.41-1.11l-1.69-1.75Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M130.3,138.44l4-1.62s7.77,2.73,10.77-.86c0,0,.78-1-5.54-1a12.63,12.63,0,0,1,7.78-3.58,9.47,9.47,0,0,1,2.68,1.07s3,.92,1.23-1.21c0,0-2.6-2.66-4.87-2.41s-15.52,3-15.52,3l-.19,0Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M127.12,144.78l4-1.62s7.77,2.73,10.77-.86c0,0,.77-1-5.54-1a12.62,12.62,0,0,1,7.77-3.58,9.47,9.47,0,0,1,2.68,1.07s3,.92,1.23-1.21c0,0-2.59-2.66-4.86-2.41s-15.52,3-15.52,3l-.19,0Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M55.38,108.87c-4.37.8-5.69,4.34-8.12,3.85-.92-.18-2.13-1-3.22-3.77a5.28,5.28,0,0,1-6.76.39,4.94,4.94,0,0,1-1.59-4.81,5.07,5.07,0,0,1,1.75-2.81A8.81,8.81,0,0,1,34,98c-2-4.39.84-8.94,1.57-10a12.55,12.55,0,0,1,6.37-4.7,9.37,9.37,0,0,1,9.55-9.71,16.52,16.52,0,0,1,.4-4,16.21,16.21,0,0,1,2-4.94,18.25,18.25,0,0,1,11.5-7.15c8.27-1.37,14.18,3.77,14.94,4.45,0,0,2.87,13.27-12,18.74,0,0,8.94,16.25-2.44,17.3-1,8-3.24,10.32-5.13,11S58.12,108.37,55.38,108.87Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M87.5,135.17,66.38,113.91a9.24,9.24,0,0,0-4.24-1.65,9.64,9.64,0,0,0-7.26,2.32c-2.8,2.69-3.42,7.41-1.29,11.49,0,0,13.35,15.23,25.43,20.43,0,0,1,4,8.91,2.81a114.11,114.11,0,0,0,42.37-5.52l-1-6.73s-40.28-1.24-41.83-1.89"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M50.77,177.78s-9.64,17.55,53,17.42l-6.71,51.16"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M86.22,246c.47-.12,26.4,1.76,26.4,1.76"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M75.88,87.62l5.79.41s-.4,4.67-2.9,4.11c0,0-2.58-.4-2.89-4.52"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "80.25 77.45 78.6 77.45 79.97 78.67"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 163.83,
    y: 110.93,
    width: 4.56,
    height: 48.07,
    transform: "translate(78.63 -60.37) rotate(26.78)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M80.57,247.06c0,2.3-8.27,4.16-18.47,4.16s-18.46-1.86-18.46-4.16,8.27-4.17,18.46-4.17S80.57,244.76,80.57,247.06Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M228.06,162.67H92.55a4.12,4.12,0,0,1,0-8.23H228.06a4.12,4.12,0,0,1,0,8.23"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 212.24,
    y: 162.67,
    width: 7.22,
    height: 111.54
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 116.91,
    y: 152.42,
    width: 41.92,
    height: 2.02
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 215.85,
    cy: 36.42,
    r: 13.42
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 274.9,
    cy: 228.23,
    r: 10.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 357.35,
    y: 19.51,
    width: 148.95,
    height: 91.63,
    rx: 13.44
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 426.06,
    y: 41.37,
    width: 53.95,
    height: 24.77,
    rx: 9.59
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-22",
    transform: "translate(433.96 60.65)"
  }, "ADS")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "457.7 78.49 447.59 88.68 453.04 88.68 453.04 105.75 462.37 105.75 462.37 88.68 468.11 88.68 457.7 78.49"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 294.38,
    cy: 97.69,
    r: 12.28
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 294.38,
    cy: 97.69,
    r: 10.61
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(289.74 103.56)"
  }, "$")), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 579.16,
    cy: 94.78,
    r: 9.37
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 579.16,
    cy: 94.78,
    r: 8.09
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-24",
    transform: "translate(575.63 99.26)"
  }, "$")), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 399.95,
    cy: 58.66,
    r: 11.42
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 399.95,
    cy: 58.66,
    r: 9.87
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-25",
    transform: "translate(395.63 64.13)"
  }, "$")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 427.28,
    y: 26.4,
    width: 68.68,
    height: 4.59,
    rx: 2.3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 381.37,
    cy: 28.7,
    r: 2.01
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 387.75,
    cy: 28.7,
    r: 2.01
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 394.21,
    cy: 28.7,
    r: 2.01
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-26",
    points: "442.84 250.44 442.84 260.99 473.29 260.99 473.29 217.63 442.84 217.63 442.84 231.32"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 446.04,
    y1: 232.6,
    x2: 461.88,
    y2: 232.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 450.38,
    y1: 238.05,
    x2: 468.3,
    y2: 238.05
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 446.71,
    y1: 249.19,
    x2: 469.42,
    y2: 249.19
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 450.55,
    y1: 243.62,
    x2: 468.13,
    y2: 243.62
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 441.42,
    cy: 241.1,
    r: 9.6,
    transform: "translate(-58.66 187.28) rotate(-22.5)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "446.05 241.78 439.03 237.73 439.03 245.84 446.05 241.78"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M647.85,250.55l3.54-1.08a4.27,4.27,0,0,0,2.94-4.64l-3.87-28.32-9.65,3,1.57,27.25a4.21,4.21,0,0,0,5.47,3.81"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M624.66,213.67c-.52-1.66-1-3.29-1.46-4.92a28,28,0,0,1,8.81-8.18c1.1,3.14,2.18,6.43,3.24,9.82s2,6.71,2.84,9.94a28,28,0,0,1-11.89-1.8c-.52-1.6-1.05-3.21-1.54-4.86"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M631.05,211.7a59.75,59.75,0,0,1-2.57-12.21l31.65-9.77,7.29,23.66-31.68,9.79a59.31,59.31,0,0,1-4.69-11.47"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M652,190.09c1.43-.45,36.77-33.25,40.59-34.53s12.21,12.87,18,31.61,7.07,34.94,2.92,36.24-51.53-6.12-53-5.69-5-5.26-7.33-12.9-3-14.21-1.19-14.73"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M695.52,191.8c5.78,18.74,13.84,32.88,18,31.61s2.85-17.4-2.92-36.24-13.84-32.88-18-31.61-2.86,17.53,2.92,36.24"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M705.45,188.69c.39,1.25.75,2.54,1.09,3.69a29.81,29.81,0,0,1-8.68,6.78c-.84-2.35-1.67-4.82-2.47-7.37s-1.47-5.08-2.13-7.47a30.19,30.19,0,0,1,11,.72,16,16,0,0,1,1.19,3.65"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 690.17,
    cy: 66.14,
    r: 16.24
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "699.02 66.14 684.53 57.78 684.53 74.51 699.02 66.14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaidadvertisingtab);
export default __webpack_public_path__ + "static/media/paid advertising tab.052baa637cbb3e2b12078edc11e1b4d7.svg";
export { ForwardRef as ReactComponent };